import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SwitchToggle from "../../components/SwitchToggle";

const SubscriptionList = () => {

  const navigate = useNavigate();

  const rows = [
    {
      id: 1,
      plan: "Basic Plan",
      price: "$400/Month",
      date: "01 March 2025"
    },
    {
      id: 2,
      plan: "Elite Plan",
      price: "$600/Year",
      date: "01 March 2025"
    },
    {
      id: 2,
      plan: "Gold Plan",
      price: "$800/Year",
      date: "01 March 2025"
    },
  ];

  return (
    <TableContainer className="table_container">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Plan Name</TableCell>
            <TableCell>Price</TableCell>
            <TableCell>Created Date</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow hover key={row.id}>
              <TableCell onClick={() => navigate("/manage-subscriptions/detail")} className="click_action"><strong>{row.plan}</strong></TableCell>
              <TableCell>{row.price}</TableCell>
              <TableCell>{row.date}</TableCell>
              <TableCell><SwitchToggle /></TableCell>
              <TableCell>
                <div className="table_actions v2">
                  <IconButton onClick={() => navigate("/manage-subscriptions/detail")}>
                    <img src="/static/images/eye_icon.svg" alt="" />
                  </IconButton>
                  <IconButton onClick={() => navigate("/manage-subscriptions/add")}>
                    <img src="/static/images/edit2_icon.svg" alt="" />
                  </IconButton>
                  <IconButton>
                    <img src="/static/images/trash2_icon.svg" alt="" />
                  </IconButton>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SubscriptionList;
